import Component from 'vue-class-component'
import Vue from "Vue";
import { Prop } from "vue-property-decorator";

@Component
export default class Loader extends Vue {
   @Prop()
   mini = false;
}



// WEBPACK FOOTER //
// ./src/shared/components/Loader/Loader.ts